module.exports = __webpack_public_path__ + "img/contributions40On.f7fa3246.svg";